// Dependency-free inline SVG category glyphs. Inherit color via currentColor.
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  width: 20,
  height: 20,
};

export const CategoryIcon = ({ name }) => {
  switch (name) {
    case 'Mobile':
      return (
        <svg {...base}><rect x="6" y="2" width="12" height="20" rx="2.5" /><line x1="11" y1="18" x2="13" y2="18" /></svg>
      );
    case 'Backend':
      return (
        <svg {...base}><rect x="3" y="4" width="18" height="7" rx="1.5" /><rect x="3" y="13" width="18" height="7" rx="1.5" /><line x1="7" y1="7.5" x2="7" y2="7.5" /><line x1="7" y1="16.5" x2="7" y2="16.5" /></svg>
      );
    case 'AI / ML':
      return (
        <svg {...base}><rect x="7" y="7" width="10" height="10" rx="2" /><line x1="12" y1="2" x2="12" y2="4" /><line x1="12" y1="20" x2="12" y2="22" /><line x1="2" y1="12" x2="4" y2="12" /><line x1="20" y1="12" x2="22" y2="12" /><line x1="4.5" y1="4.5" x2="6" y2="6" /><line x1="18" y1="18" x2="19.5" y2="19.5" /></svg>
      );
    case 'Robotics / Hardware':
      return (
        <svg {...base}><rect x="5" y="8" width="14" height="11" rx="2" /><circle cx="9" cy="13" r="1" /><circle cx="15" cy="13" r="1" /><line x1="12" y1="4" x2="12" y2="8" /><circle cx="12" cy="3" r="1" /></svg>
      );
    case 'Tooling':
      return (
        <svg {...base}><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.3-.6-.6-2.3z" /></svg>
      );
    default:
      return (
        <svg {...base}><circle cx="12" cy="12" r="9" /></svg>
      );
  }
};
